<app-info-modal title="Modo Adesão">
    <div class="eu-display_flex eu-column offer-modal-body">
        <div>
            <p class="emd-text _size_section _color_default">
                Com a habilitação da feature, o parceiro terá acesso ao
                <strong class="emd-text">Modo Adesão</strong>
            </p>
        </div>
        <div>
            <p class="emd-text _size_section _color_default">
                A estrutura de adesão é diferente pois a oferta de terminais se dá no modelo de
                comodato e não de mensalidade. Ou seja, a única cobrança referente aos terminais
                Stone é a taxa de adesão que é paga no início da parceria. Caso o cliente deseje
                encerrar a parceria com a Stone, os termianis serão recolhidos pelo time de
                logística.
            </p>
        </div>
    </div>
</app-info-modal>
